<div class="container-fluid cards-container">
    @let kpi = kpis()[0];
    <div class="row g-3">
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.hixBCriterion.title"
                [body]="{
                    value: kpi.hixBCriterion,
                    suffix: texts.hixBCriterion.suffix,
                    precision: texts.hixBCriterion.precision,
                }"
                [badge]="{
                    value: kpi.hixBCriterionEvolution,
                    suffix: texts.hixBCriterion.badgeSuffix,
                    precision: texts.hixBCriterion.badgePrecision,
                    style: kpi.hixBCriterionEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.hixBCriterion.descriptionTitle"
                [descriptionContent]="texts.hixBCriterion.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'hixBCriterion')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.tccBCriterion.title"
                [body]="{
                    value: kpi.tccBCriterion,
                    suffix: texts.tccBCriterion.suffix,
                    precision: texts.tccBCriterion.precision,
                }"
                [badge]="{
                    value: kpi.tccBCriterionEvolution,
                    suffix: texts.tccBCriterion.badgeSuffix,
                    precision: texts.tccBCriterion.badgePrecision,
                    style: kpi.tccBCriterionEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.tccBCriterion.descriptionTitle"
                [descriptionContent]="texts.tccBCriterion.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'tccBCriterion')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.incidentBCriterion.title"
                [body]="{
                    value: kpi.incidentBCriterion,
                    suffix: texts.incidentBCriterion.suffix,
                    precision: texts.incidentBCriterion.precision,
                }"
                [badge]="{
                    value: kpi.incidentBCriterionEvolution,
                    suffix: texts.incidentBCriterion.badgeSuffix,
                    precision: texts.incidentBCriterion.badgePrecision,
                    style: kpi.incidentBCriterionEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.incidentBCriterion.descriptionTitle"
                [descriptionContent]="texts.incidentBCriterion.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'incidentBCriterion')"
                cardClass="h-100">
            </kpi-card>
        </div>
    </div>

    <div class="row g-3">
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="breakdownChart"
                [title]="texts.BCriterionBreakdownChart.title"
                [error]="breakdownChartError"
                [isLoading]="!breakdownchartData()[0].organizationId"
                [series]="breakdownChartSeries"
                [dataLabels]="breakdownDataLabels"
                [stacked]="true"
                [xaxisCategories]="breakdownXaxisCategories"
                [yaxis]="breakdownYaxis"
                [xaxisTitle]="texts.BCriterionBreakdownChart.xaxisTitle"
                [unitTooltip]="texts.BCriterionBreakdownChart.unitTooltip"
                class="h-100">
            </chart-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="enedisInvestmentChart"
                [title]="texts.BCriterionEnedisInvestmentChart.title"
                [error]="enedisInvestmentChartError"
                [isLoading]="!enedisInvestmentChartData()[0].organizationId"
                [series]="enedisInvestmentChartSeries"
                [dataLabels]="enedisInvestmentDataLabels"
                [stacked]="false"
                [xaxisCategories]="enedisInvestmentXaxisCategories"
                [yaxis]="enedisInvestmentYaxis"
                [grid]="enedisInvestmentGrid"
                [customTooltip]="enedisInvestmentCustomTooltip"
                [xaxisTitle]="texts.BCriterionEnedisInvestmentChart.xaxisTitle"
                class="h-100">
            </chart-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <geo-map-card
                [mapId]="'continuityQualitySupplyMeanTccBCriterionMap'"
                [title]="texts.meanTccBCriterionMap.title"
                [descriptionContent]="texts.meanTccBCriterionMap.descriptionContent"
                [descriptionTitle]="texts.meanTccBCriterionMap.descriptionTitle"
                [geometries]="meanTccGeometriesSignal()"
                [isLoading]="!meanTccGeometriesSignal()[0].organizationId"
                [error]="!!meanTccGeometriesSignal()[0].error"
                [getStyle]="setMapStyle('meanTccBCriterion')"
                [legendConfig]="meanTccLegendConfig"
                [getTooltip]="setTooltip('meanTccBCriterion')"></geo-map-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <geo-map-card
                [mapId]="'continuityQualitySupplyMeanHixBCriterionMap'"
                [title]="texts.meanHixBCriterionMap.title"
                [descriptionContent]="texts.meanHixBCriterionMap.descriptionContent"
                [descriptionTitle]="texts.meanHixBCriterionMap.descriptionTitle"
                [geometries]="meanHixGeometriesSignal()"
                [isLoading]="!meanHixGeometriesSignal()[0].organizationId"
                [error]="!!meanHixGeometriesSignal()[0].error"
                [getStyle]="setMapStyle('meanHixBCriterion')"
                [legendConfig]="meanHixLegendConfig"
                [getTooltip]="setTooltip('meanHixBCriterion')"></geo-map-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <geo-map-card
                [mapId]="'continuityQualitySupplyTccBCriterionMap'"
                [title]="texts.tccBCriterionMap.title"
                [descriptionContent]="texts.tccBCriterionMap.descriptionContent"
                [descriptionTitle]="texts.tccBCriterionMap.descriptionTitle"
                [geometries]="tccGeometriesSignal()"
                [isLoading]="!tccGeometriesSignal()[0].organizationId"
                [error]="!!tccGeometriesSignal()[0].error"
                [getStyle]="setMapStyle('tccBCriterion')"
                [legendConfig]="tccLegendConfig"
                [getTooltip]="setTooltip('tccBCriterion')"></geo-map-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <geo-map-card
                [mapId]="'continuityQualitySupplyHixBCriterionMap'"
                [title]="texts.hixBCriterionMap.title"
                [descriptionContent]="texts.hixBCriterionMap.descriptionContent"
                [descriptionTitle]="texts.hixBCriterionMap.descriptionTitle"
                [geometries]="hixGeometriesSignal()"
                [isLoading]="!hixGeometriesSignal()[0].organizationId"
                [error]="!!hixGeometriesSignal()[0].error"
                [getStyle]="setMapStyle('hixBCriterion')"
                [legendConfig]="hixLegendConfig"
                [getTooltip]="setTooltip('hixBCriterion')"></geo-map-card>
        </div>
    </div>
</div>
